import React from 'react';

const DieLineLegend: React.FC = () => (
  <div className="die-line__legend">
    <span className="die-line__legend-item die-line__legend-item--cut">
      Cut
    </span>
    <span className="die-line__legend-item die-line__legend-item--crease">
      Crease
    </span>
  </div>
);

export default DieLineLegend;
